import React from 'react'
import { Link } from 'react-router-dom'
import { CAPABILITIES_SECTIONS } from './capabilitiesData'

/**
 * Bottom navigation carousel for stepping through capability pages.
 * Shows: ← Previous | numbered dots | Next →
 */
const CapabilityPageNav = ({ currentSlug }) => {
    const currentIdx = CAPABILITIES_SECTIONS.findIndex(s => s.slug === currentSlug)
    const prev = currentIdx > 0 ? CAPABILITIES_SECTIONS[currentIdx - 1] : null
    const next = currentIdx < CAPABILITIES_SECTIONS.length - 1 ? CAPABILITIES_SECTIONS[currentIdx + 1] : null

    return (
        <nav className="cap-page-nav" aria-label="Capability pages navigation">
            <div className="cap-page-nav-inner">
                {/* Previous */}
                <div className="cap-page-nav-prev">
                    {prev ? (
                        <Link to={`/capabilities/${prev.slug}`} className="cap-page-nav-link">
                            <span className="cap-page-nav-arrow">←</span>
                            <span className="cap-page-nav-label">
                                <span className="cap-page-nav-dir">Previous</span>
                                <span className="cap-page-nav-title">{prev.shortTitle}</span>
                            </span>
                        </Link>
                    ) : <span />}
                </div>

                {/* Numbered dots */}
                <div className="cap-page-nav-dots">
                    {CAPABILITIES_SECTIONS.map((s, i) => (
                        <Link
                            key={s.slug}
                            to={`/capabilities/${s.slug}`}
                            className={`cap-page-nav-dot${i === currentIdx ? ' active' : ''}`}
                            title={s.title}
                        >
                            {s.num}
                        </Link>
                    ))}
                </div>

                {/* Next */}
                <div className="cap-page-nav-next">
                    {next ? (
                        <Link to={`/capabilities/${next.slug}`} className="cap-page-nav-link">
                            <span className="cap-page-nav-label">
                                <span className="cap-page-nav-dir">Next</span>
                                <span className="cap-page-nav-title">{next.shortTitle}</span>
                            </span>
                            <span className="cap-page-nav-arrow">→</span>
                        </Link>
                    ) : <span />}
                </div>
            </div>
        </nav>
    )
}

export default CapabilityPageNav
